import HomeIcon from "@mui/icons-material/Home";
import BusinessIcon from "@mui/icons-material/Business";
import ReceiptIcon from "@mui/icons-material/Receipt";
import AssessmentIcon from "@mui/icons-material/Assessment";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";

export const menuSections = [
  {
    title: "Home",
    icon: HomeIcon,
    items: [
      {
        text: "Dashboard",
        path: "/dashboard/usermaster",
        role: "MasterList",
      },
    ],
  },
  {
    title: "Master",
    icon: BusinessIcon,
    items: [
      {
        text: "Company Master",
        path: "/dashboard/CompanyMaster",
        role: "Pending_Requests",
      },
      {
        text: "Plant Master",
        path: "/dashboard/PlantMaster",
        role: "Pending_Requests_Emp",
      },
      {
        text: "Location Master",
        path: "/dashboard/LocationMaster",
        role: "Pending_Requests_Emp",
      },
      {
        text: "Sub Loacation Master",
        path: "/dashboard/SubLocationMaster",
        role: "Pending_Requests_Emp",
      },
      {
        text: "Department Master",
        path: "/dashboard/DepartmentMaster",
        role: "Pending_Requests_Emp",
      },
      {
        text: "Asset Category Code",
        path: "/dashboard/CategoryMaster",
        role: "Pending_Requests_Emp",
      },
      {
        text: "Asset Master",
        path: "/dashboard/AssetMaster",
        role: "Pending_Requests_Emp",
      },
      {
        text: "Customer Master",
        path: "/dashboard/CustomerMaster",
        role: "Pending_Requests_Emp",
      },
      {
        text: "Employee Master",
        path: "/dashboard/EmployeeMaster",
        role: "Pending_Requests_Emp",
      },
      {
        text: "Email Master",
        path: "/dashboard/EmailMaster",
        role: "Pending_Requests_Emp",
      },
    ],
  },
  {
    title: "Transction",
    icon: ReceiptIcon,
    items: [
      {
        text: "Print Asset Barcode",
        path: "/dashboard/PrintAssetBarcode",
        role: "Find",
      },
      {
        text: "Reprint Asset Barcode",
        path: "/dashboard/ReprintAssetBarcode",
        role: "Visitor_InOut",
      },
      {
        text: "Generated Barcode",
        path: "/dashboard/GenrateBarcodeAsset",
        role: "AllEntries",
      },
    ],
  },
  {
    title: "Admin Reports",
    icon: AssessmentIcon,
    items: [
      {
        text: "Rep-Generate Barcode",
        path: "/dashboard/ReportAssetGenerateBarcode",
        role: "AllEntries",
      },
      {
        text: "Rep-Asset Identification",
        path: "/dashboard/ReportAssetIdentification",
        role: "AllEntries",
      },
      {
        text: "Rep-Available Asset",
        path: "/dashboard/ReportAvailableAsset",
        role: "AllEntries",
      },
      {
        text: "Rep-Asset Assign",
        path: "/dashboard/ReportAssetAssign",
        role: "AllEntries",
      },
      {
        text: "Rep-Asset De-Assign",
        path: "/dashboard/ReportAssetDeAssign",
        role: "AllEntries",
      },
      {
        text: "Rep-Asset Issued",
        path: "/dashboard/ReportAssetIssued",
        role: "AllEntries",
      },
      {
        text: "Rep-Pending For Receipt",
        path: "/dashboard/ReportAssetPendingFRec",
        role: "AllEntries",
      },
      {
        text: "Rep-Asset Receipt",
        path: "/dashboard/ReportAssetReceipt",
        role: "AllEntries",
      },
      {
        text: "Rep-In Transit Diversion",
        path: "/dashboard/ReportAssetInTransitDiversion",
        role: "AllEntries",
      },
      {
        text: "Rep-Asset Depreciation",
        path: "/dashboard/ReportAssetDepreciation",
        role: "AllEntries",
      },
      {
        text: "Rep-Physical Stock Take",
        path: "/dashboard/RepAssetPhStockTake",
        role: "AllEntries",
      },
      {
        text: "Rep-Asset OverAll",
        path: "/dashboard/ReportAssetOverAllReport",
        role: "AllEntries",
      },
      {
        text: "Rep-Cost Depreciation",
        path: "/dashboard/ReportCostDepreciation",
        role: "AllEntries",
      },
    ],
  },
  {
    title: "Administrator",
    icon: AdminPanelSettingsIcon,
    items: [
      {
        text: "User Master",
        path: "/dashboard/UserMaster",
        role: "AllEntries",
      },
      {
        text: "User Role Master",
        path: "/dashboard/UserRoleMaster",
        role: "AllEntries",
      },
      {
        text: "Change Password",
        path: "/dashboard/",
        role: "AllEntries",
      },
      {
        text: "Android App Access",
        path: "/dashboard/",
        role: "AllEntries",
      },
    ],
  },
];

